import type { PlayLike } from '../@types/editor'

type ClosablePlaysStore<TPlay> = {
  discardPlay: (playId: string) => void
  plays: TPlay[]
}

// the play before a closed empty play ends up centered, where quick picks replacing it would end up
export const useEditorClosePlay = <TPlay extends PlayLike & { id: string }>(
  store: ClosablePlaysStore<TPlay>,
) => {
  const { scrollToCenteredPlay } = useEditorScroll()

  return async (playId: string) => {
    const index = store.plays.findIndex(({ id }) => id === playId)
    if (index < 0) return

    const neighbor = store.plays[index - 1] ?? store.plays[index + 1]
    store.discardPlay(playId)
    await scrollToCenteredPlay(neighbor?.id)
  }
}
